var _path, _path2, _line, _line2, _line3, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActionarePrinProtectiaTermicaLaSupracurent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 83,
    viewBox: "0 0 76 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 25L1 6.5",
    stroke: "black",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 53L1 34.5",
    stroke: "black",
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 29.5,
    x2: 18,
    y2: 29.5,
    stroke: "black",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 21,
    y1: 29.5,
    x2: 30,
    y2: 29.5,
    stroke: "black",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 33,
    y1: 29.5,
    x2: 42,
    y2: 29.5,
    stroke: "black",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 25.5H8V34.5H0",
    stroke: "black",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionarePrinProtectiaTermicaLaSupracurent);
export default __webpack_public_path__ + "static/media/actionare_prin_protectia_termica_la_supracurent.dc202a0ce150c884d450c574ca778de7.svg";
export { ForwardRef as ReactComponent };